// extracted by mini-css-extract-plugin
export default {"deviceButton":"ToggleBackgroundEffectsButton_deviceButton__ncy+9","icon":"ToggleBackgroundEffectsButton_icon__vuj47"};